import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-details.module.scss';
import UnstakingStepThreeBg from '../../../../../../../assets/stake/unstaking-step-three.svg';
import Header from '../../../../../../../components/Stake/header';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import * as pkfStakeActions from '../../../../../../../actions/pkf-stake-actions';
import { formatToken } from '../../../../../../../helpers/token-helper';
import PKFIcon from '../../../../../../../assets/images/tokens/PKF.png';
import { PKF } from '../../../../../../../constants/blockchain-constants';

const UnstakeDetails = () => {
  const dispatch = useDispatch();

  const colors = useGetTheme();
  const { amount } = useSelector((state) => state.PKFstake.stake);

  return (
    <>
      <Header
        icon={PKFIcon}
        title={`${PKF}-Unstaking`}
        onClickBack={() => dispatch(pkfStakeActions.unstakeInformation({ amount }))}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>You are unstaking</div>
        <div className={styles.value}>
          {formatToken(amount)} {PKF}
        </div>
        <img className={styles.image} src={UnstakingStepThreeBg} alt='' />
        <div>
          <div className={styles.descriptionItem}>
            <span>*</span> There is an 8 day unstaking period before you can withdraw your staked
            tokens. Following that 8 day unstaking period you will be able to withdraw.
          </div>
          <div className={styles.descriptionItem}>
            <span>**</span> Staking rewards will stop being earned as soon as you click "Unstake"
            and initiate the unstaking process.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(pkfStakeActions.unstakeSend({ amount }))}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Unstake
          </Button>
        </div>
      </div>
    </>
  );
};

export default UnstakeDetails;
